export default __webpack_public_path__ + "static/media/Faculty.08a884d4.png";